<!--Copy right - © 2024 tecera gmbh-->
<script>
    import { last_meta_data } from "../stores.js";
    import {fade} from "svelte/transition";
    
    let show_rssi = false;
    let last_rssi;
    let last_transmit;
    let status = "bad";

    function format_date(input_string) {
        // Create a Date object from the input string
        let date = new Date(input_string);
        // Format the Date object into the desired format
        let formattedString =
            date.getDate().toString().padStart(2, "0") +
            "." +
            (date.getMonth() + 1).toString().padStart(2, "0") +
            "." +
            date.getFullYear() +
            " " +
            date.getHours().toString().padStart(2, "0") +
            ":" +
            date.getMinutes().toString().padStart(2, "0");
        return formattedString;
    }


    $: {
        if ($last_meta_data != null) {
            last_rssi = $last_meta_data["rssi"];
            last_transmit = format_date($last_meta_data["send_at"]);
        }
    }

    $: if (last_rssi > -100) {
        status = "perfect";
    } else if (last_rssi > -107) {
        status = "good";
    } else if (last_rssi > -115) {
        status = "ok";
    } else {
        status = "bad";
    }
</script>


{#if $last_meta_data && $last_meta_data["rssi"] != null}
            <div class="signal-bars sizing-box mb-1 {status}" id="last_signal" on:mouseenter={() => (show_rssi = true)}
                on:mouseleave={() => (show_rssi = false)} 
                in:fade
                >
                <div class="bar first-bar"></div><div class="bar second-bar"></div><div class="bar third-bar"></div><div class="bar fourth-bar"></div>
            </div>

            <div class="ml-1 mb-1" in:fade>
            <p
                class="sendezeitraum {status}  pointer {show_rssi
                    ? ''
                    : 'not-visible'}"
                id="last_rssi"
            >
                {last_rssi} dbm
            </p>
            <p class="sendezeitraum {status}  pointer" id="last_transmit" style="white-space: nowrap;">
                {last_transmit}
            </p>
        </div>
{:else}
            <div class="signal-bars sizing-box noData mb-1" 
                id="last_signal"
                on:mouseenter={() => (show_rssi = true)}
                on:mouseleave={() => (show_rssi = false)}
                in:fade
                >
                <div class="bar first-bar"></div><div class="bar second-bar"></div><div class="bar third-bar"></div><div class="bar fourth-bar"></div>
            </div>
            <div class="ml-1 mb-1" in:fade>
                <p
                    class="sendezeitraum noData  pointer {show_rssi
                        ? ''
                        : 'not-visible'}"
                    id="last_rssi"
                >
                </p>
                <p class="sendezeitraum noData  pointer" id="last_transmit">
                    keine Daten
                </p>
            </div>
{/if}